import { render, staticRenderFns } from "./AktivaForm.vue?vue&type=template&id=144aa31c&scoped=true&"
import script from "./AktivaForm.vue?vue&type=script&lang=js&"
export * from "./AktivaForm.vue?vue&type=script&lang=js&"
import style0 from "./AktivaForm.vue?vue&type=style&index=0&id=144aa31c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144aa31c",
  null
  
)

export default component.exports